import { convertValues } from "./convertValues";
import { FILTER_FIELDS } from "../constants/filterFields";

const mergeLimitsWithFilter = (
  limits,
  filter,
  removeNullValues = false,
  applyOnlyRemoveToFilter = false
) => {
  const alwaysAddToFilter = [
    "brandId",
    "phoneId",
    "phoneVariantEan",
    "phoneVariantId"
  ];

  let mergedLimitsWithFilter = { ...filter };

  // remove keys that are empty
  if (removeNullValues) {
    Object.keys(mergedLimitsWithFilter).forEach(
      (key) =>
        mergedLimitsWithFilter[key] == null &&
        delete mergedLimitsWithFilter[key]
    );
  }

  mergedLimitsWithFilter = convertValues(mergedLimitsWithFilter, FILTER_FIELDS);

  for (const key of Object.keys(limits)) {
    if (Array.isArray(limits[key]) && limits[key].length) {
      if (mergedLimitsWithFilter[key]) {
        if (Array.isArray(mergedLimitsWithFilter[key])) {
          let newValueArray = [];
          if (mergedLimitsWithFilter[key].length) {
            for (const value of mergedLimitsWithFilter[key]) {
              if (limits[key].indexOf(value) >= 0) {
                newValueArray.push(value);
              }
            }
          } else if (
            !applyOnlyRemoveToFilter ||
            alwaysAddToFilter.indexOf(key) >= 0
          ) {
            newValueArray = limits[key];
          }
          mergedLimitsWithFilter[key] = newValueArray;
        } else if (limits[key].indexOf(mergedLimitsWithFilter[key]) < 0) {
          delete mergedLimitsWithFilter[key];
        }
      } else if (
        !applyOnlyRemoveToFilter ||
        alwaysAddToFilter.indexOf(key) >= 0
      ) {
        mergedLimitsWithFilter[key] = limits[key];
      }
    } else if (!Array.isArray(limits[key]) && limits[key]) {
      if (
        mergedLimitsWithFilter[key] ||
        !applyOnlyRemoveToFilter ||
        alwaysAddToFilter.indexOf(key) >= 0
      ) {
        mergedLimitsWithFilter[key] = limits[key];
      }
    }
  }
  return mergedLimitsWithFilter;
};

export { mergeLimitsWithFilter };
